import React, { useEffect, useState } from "react";
import { TextField, Button } from "@mui/material";
// import QuotationDocs from "./QuotationDocs";
// import RelatedDocs from "./RelatedDocs";
import Box from "@mui/material/Box";
import { Switch, FormControlLabel } from "@mui/material";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import QuotationCommentContainer from "../modals/QuotationCommentContainer";
import axios from "axios";
import { format } from "date-fns";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const SaleTabSalesOrder = ({
  selectedLead,
  customerType,
  onCustomerTypeChange,
  productsInQuotationState,
  vat,
  setVat,
  callApisAgainInQuoteLead,
  giveNextActionArrayToParent,
  lpoNoState,
  setLpoNoState,
  projectname,
  setprojectname,
}) => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : [];

  console.log(
    "project name > sale tab customer_name_from_sales_order_details ",
    projectname,
    productsInQuotationState,
  );

  const [customerAccount, setCustomerAccount] = useState(""); // State to hold the TRN value

  const [currentUserAccessGroup, setCurrentUserGroupAccess] = useState(null);

  const [commentState, setCommentState] = useState("");

  const handleComment = (e) => {
    setCommentState(e.target.value);
  };

  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);

  const [openSubmitSnackbarFailure, setOpenSubmitSnackbarFailure] =
    useState(false);

  const [fullHistoryOfStatusChange, setFullHistoryOfStatusChange] =
    useState(null);

  const handleCustomerAccountChange = (event) => {
    setCustomerAccount(event.target.value); // Update the TRN value based on user input
  };

  console.log(
    "productsInQuotationState in SaleTabSalesOrder selectedLead",
    productsInQuotationState,
    selectedLead,
  );

  const [localCustomerType, setLocalCustomerType] = useState(customerType);
  const [nextActionArray, setNextActionArray] = useState(null);
  const [nextActionSelectedByUser, setNextActionSelectedByUser] =
    useState(null);

  const handleChange = (event) => {
    const newCustomerType = event.target.value;
    setLocalCustomerType(newCustomerType);
    onCustomerTypeChange(newCustomerType); // This sends the updated value to the parent component
  };

  const handleNextActionSelection = (event) => {
    setNextActionSelectedByUser(event.target.value);
  };

  const handleVATChange = (event) => {
    console.log("event.target.value", event.target.value);
    setVat(event.target.value);
  };

  const initialdefaultVatApplied = () => {
    setVat(vat);
  };

  useEffect(() => {
    console.log("vat", vat);
  }, [vat]);

  useEffect(() => {
    if (nextActionArray) {
      giveNextActionArrayToParent(nextActionArray);
    }
  }, [nextActionArray]);

  useEffect(() => {
    initialdefaultVatApplied();
  }, []);

  const callApiToGetNextActionList = (receivedProductInQuotationState) => {
    console.log(
      "receivedProductInQuotationState ",
      receivedProductInQuotationState,
    );

    let compcode = COMPANY_CODE;
    let mode = "SOSTATUSOPTIONS";
    let task_owner_id = receivedProductInQuotationState
      ? receivedProductInQuotationState[0].area_code != ""
        ? receivedProductInQuotationState[0].area_code
        : "Draft"
      : "-";
    let task_id = "-";

    const apiUrl = `${API_PATHS[0].API_CONFIG}/api/CRMTaskHistoryList/${compcode}/${mode}/${task_owner_id}/${task_id}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setNextActionArray(res.data);
      })
      .catch((err) => {});
  };

  const callApiToGetFullHistoryOfStatusChange = (
    receivedProductInQuotationState,
  ) => {
    console.log(
      "callApiToGetFullHistoryOfStatusChange SaleTab ",
      receivedProductInQuotationState,
      selectedLead,
    );

    const currentUserfromLocalStorage = JSON.parse(
      localStorage.getItem("currentUser"),
    );

    let currentUserEMPID = "-";

    if (currentUserfromLocalStorage) {
      console.log(
        "currentUserfromLocalStorage[0] ",
        currentUserfromLocalStorage[0],
      );
      currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
    } else {
      console.log(
        "currentUserfromLocalStorage[0] else",
        currentUserfromLocalStorage[0],
      );
    }

    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroupNow = currentUserObject[0].accessgrp;

    let compcode = COMPANY_CODE;
    let mode = "SOTIMELINE";
    let task_owner_id = selectedLead.deptno
      ? selectedLead.deptno
      : productsInQuotationState[0]?.dept_from_so_details;
    let task_id = productsInQuotationState
      ? productsInQuotationState[0]?.quotation_number + ""
      : "NEW";

    const apiUrl = `${API_PATHS[0].API_CONFIG}/api/CRMTaskHistoryList/${compcode}/${mode}/${task_owner_id}/${task_id}`;

    console.log("apiurl >> status change", apiUrl);
    axios
      .get(apiUrl)
      .then((res) => {
        setFullHistoryOfStatusChange(res.data);
      })
      .catch((err) => {});
  };

  const callAPIToChangeStatus = (comment) => {
    console.log(
      "productsInQuotationState >> selectedLead>> callAPIToChangeStatus",
      productsInQuotationState,
      selectedLead,
    );

    const currentUserfromLocalStorage = JSON.parse(
      localStorage.getItem("currentUser"),
    );

    let currentUserEMPID = "-";

    if (currentUserfromLocalStorage) {
      console.log(
        "currentUserfromLocalStorage[0] ",
        currentUserfromLocalStorage[0],
      );
      currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
    } else {
      console.log(
        "currentUserfromLocalStorage[0] else",
        currentUserfromLocalStorage[0],
      );
    }

    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroupNow = currentUserObject[0].accessgrp;

    console.log(
      "userAccessGroupNow  selectedLead.deptno >>",
      userAccessGroupNow,
      selectedLead.deptno,
    );

    const jsonObject = [
      {
        CmpCode: COMPANY_CODE,
        mode: "SALESORDER",
        DocNo: productsInQuotationState
          ? productsInQuotationState[0]?.quotation_number + ""
          : "NEW",
        deptno: selectedLead.deptno
          ? selectedLead.deptno
          : productsInQuotationState[0]?.dept_from_so_details,
        Status: nextActionSelectedByUser?.trim(),
        Comments: comment,
        UserID: currentUserEMPID?.trim(),
        created_on: format(new Date(), "yyyy-MM-dd"),
      },
    ];

    const jsonToSend = JSON.stringify(jsonObject);

    const apiUrl = `${API_PATHS[0].API_CONFIG}/api/ProposalStatus`;

    axios
      .post(apiUrl, jsonToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.result === "Saved") {
          setOpenSubmitSnackbar(true);

          setCommentState("");

          callApisAgainInQuoteLead(selectedLead.Prop_No);
        } else {
          setOpenSubmitSnackbarFailure(true);
        }
      })
      .catch((err) => {});
  };

  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
    setOpenSubmitSnackbarFailure(false);
  };

  useEffect(() => {
    if (productsInQuotationState) {
      if (productsInQuotationState[0]) {
        console.log(
          "productsInQuotationState[0].so_ref",
          productsInQuotationState[0].so_ref,
        );

        setLpoNoState(
          productsInQuotationState[0].so_ref
            ? productsInQuotationState[0].so_ref
            : "",
        );
        callApiToGetNextActionList(productsInQuotationState);
        callApiToGetFullHistoryOfStatusChange(productsInQuotationState);
      }
    }
  }, [productsInQuotationState]);

  const handleInputLPO = (e) => {
    setLpoNoState(e.target.value);
  };

  useEffect(() => {
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroup = currentUserObject[0].accessgrp;
    setCurrentUserGroupAccess(userAccessGroup);
  }, []);

  return (
    <div style={{ display: "flex", alignItems: "flex-end" }}>
      <div
        className="flex flex-col justify-between items-left gap-4"
        style={{ width: "60%" }}
      >
        <div className="flex gap-4" style={{ width: "100%" }}>
          <p style={{ display: "flex", flexDirection: "column" }}>
            {" "}
            <span style={{ color: "#a7a7a7" }}>Stage </span>
            <span>
              {productsInQuotationState
                ? productsInQuotationState[0]?.area_code != ""
                  ? productsInQuotationState[0]?.area_code
                  : "Draft"
                : "DRAFT--"}
            </span>
          </p>

          <div>
            {
              <FormControl sx={{ minWidth: "140px" }} variant="standard">
                <InputLabel>Next Action</InputLabel>
                <Select
                  value={nextActionSelectedByUser}
                  onChange={handleNextActionSelection}
                >
                  {nextActionArray?.map((item) => {
                    return (
                      <MenuItem value={item.new_status}>
                        {item.new_status}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            }
          </div>

          <p style={{ display: "flex", flexDirection: "column" }}>
            {" "}
            <span style={{ color: "#a7a7a7" }}>Sales Order No </span>
            <span>
              {selectedLead
                ? selectedLead?.so_no
                  ? selectedLead?.so_no
                  : selectedLead?.Salesorder_No
                : "NEW"}
            </span>
          </p>

          <p style={{ display: "flex", flexDirection: "column" }}>
            {" "}
            <span style={{ color: "#a7a7a7" }}>Qtn No </span>
            <span>
              {selectedLead?.qtn_no
                ? selectedLead?.qtn_no
                : selectedLead?.Prop_No
                  ? selectedLead?.Prop_No
                  : selectedLead?.Proposal_No}
            </span>
          </p>

          <p style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "#a7a7a7" }}>Lead ID</span>
            <span>{selectedLead?.Lead_ID}</span>
          </p>
        </div>

        <div className="flex justify-left items-center gap-8 ">
          <div className="w-40 ">
            <FormControl fullWidth variant="standard">
              <InputLabel>VAT Category</InputLabel>
              <Select value={vat} onChange={handleVATChange}>
                {/* <MenuItem value=''>Select VAT Options</MenuItem> */}
                <MenuItem value="noVat">0% (No VAT)</MenuItem>
                <MenuItem value="vatApplied">VAT Applied</MenuItem>
                <MenuItem value="vatExempted">VAT Exempted</MenuItem>
                <MenuItem value="outOfScope">Out of Scope</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="flex gap-4">
          <div>
            <p className="font-light text-[#00000099] text-xs">
              Customer/Organization
            </p>
            <span>
              {productsInQuotationState &&
                productsInQuotationState[0]
                  ?.customer_name_from_sales_order_details}
            </span>
          </div>

          <div>
            <p className="font-light text-[#00000099] text-xs">
              Customer Account
            </p>
            <span>
              {productsInQuotationState &&
                productsInQuotationState[0]
                  ?.customer_account_from_sales_order_details}
            </span>
          </div>
        </div>

        <div>
          <TextField
            label="Enter LPO No"
            value={lpoNoState}
            size="small"
            variant="standard"
            onChange={(e) => handleInputLPO(e)}
          />
        </div>

        <div>
          <TextField
            label="Enter project name"
            value={projectname}
            size="small"
            variant="standard"
            onChange={(e) => setprojectname(e.target.value)}
          />
        </div>
      </div>

      <div style={{ width: "40%" }}>
        {productsInQuotationState &&
          productsInQuotationState[0]?.quotation_number != "" && (
            <QuotationCommentContainer
              callAPIToChangeStatus={callAPIToChangeStatus}
              fullHistoryOfStatusChange={fullHistoryOfStatusChange}
              productsInQuotationState={productsInQuotationState}
              nextActionSelectedByUser={nextActionSelectedByUser}
              handleComment={handleComment}
              commentState={commentState}
              setCommentState={setCommentState}
              setNextActionSelectedByUser={setNextActionSelectedByUser}
            />
          )}
      </div>

      {/* <div className="flex flex-col gap-4 justify-center items-center">
        <TextField
          label="Quotation Date"
          value={selectedQuotationDate}
          size="small"  
          variant="standard"
          InputProps={{
            readOnly: true,
          }}
        />
        <TextField
          label="Promised Date"
          value={selectedPromisedDate}
          size="small"
          variant="standard"
          type="datetime-local"
          onChange={handlePromisedDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Followup Date"
          value={selectedFollowupDate}
          size="small"
          variant="standard"
          type="datetime-local"
          onChange={handleFollowupDateChange}
          InputLabelProps={{ shrink: true }}
        /> 
      </div> */}

      <Snackbar
        open={openSubmitSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSubmitSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert severity="success" sx={{ width: "100%" }}>
          Successfully Saved!
        </MuiAlert>
      </Snackbar>

      <Snackbar
        open={openSubmitSnackbarFailure}
        autoHideDuration={3000}
        onClose={handleCloseSubmitSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert severity="success" sx={{ width: "100%" }}>
          Something went wrong, Please try later
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default SaleTabSalesOrder;
